import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

import { handleQuerySuccess } from '../../../../hooks/useQuriesSuccess';
import { apiRequest } from '../../../../Services/Common/ApiRequest';
import Global from '../../../../Services/Common/Global';
import useDeleteMutation from '../../../../hooks/apis/useDeleteMutaion';
import useSaveMutation from '../../../../hooks/apis/useSaveMutaion';
import { mapParamsBySchema, mapRowsBySchema } from '../../../../util';
import { ACS_BASIC_01_Schema } from './ACS_BASIC_01_Schema';

/**
 * 산업재해현황(ACS_BASIC_01) 관련 React Query 훅
 * - 기본 조회(useQuery): useSearch1
 * - 삭제/저장(useMutation 기반): useDelete1, useSave1
 */
export const useSearch1 = (options = {}) => {
  const { onSuccess } = options;
  const params = mapParamsBySchema(ACS_BASIC_01_Schema.mapper.search1);

  const query = useQuery({
    queryKey: ['AccidentStatus', 'getAccBasic01R1', params],
    queryFn: () =>
      apiRequest('post', Global.urls.AccidentStatus.getAccBasic01R1, params),
    enabled: true,
  });

  useEffect(() => {
    if (!query.isSuccess) return;
    handleQuerySuccess(query.data, {
      onSuccess: async (rows) => {
        await onSuccess?.(rows);
      },
    });
  }, [query.isSuccess, query.dataUpdatedAt]);

  return query;
};

/**
 * 산업재해현황 저장 (SaveAccBasic01U1)
 */
export const useSave1 = (options = {}) => {
  return useSaveMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, ACS_BASIC_01_Schema.mapper.save1);

    return apiRequest(
      'post1',
      Global.urls.AccidentStatus.saveAccBasic01U1,
      payload
    );
  }, options);
};

/**
 * 산업재해현황 삭제 (DeleteAccBasic01D1)
 */
export const useDelete1 = (options = {}) => {
  return useDeleteMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, ACS_BASIC_01_Schema.mapper.delete1);

    return apiRequest(
      'post1',
      Global.urls.AccidentStatus.deleteAccBasic01D1,
      payload
    );
  }, options);
};

